import axios from "axios";
import { bus } from "@/main";
import VueCookies from 'vue-cookies'


// const developmentUrl = "https://cms.schools.portodesignbiennale.pt/wp-json/";
const developmentUrl = "http://localhost:4083/wp-json/";
// const developmentUrl = "http://192.168.1.73:4083/wp-json/";
const productionUrl = "https://cms.schools.portodesignbiennale.pt/wp-json/";

export const API = axios.create({
	baseURL: process.env.NODE_ENV === "development" ? developmentUrl : productionUrl,
	headers: {
		"Content-Type": "application/json",
	}
})

API.interceptors.request.use(
	function (config) {
		const token = VueCookies.get("token");

		if (token) config.headers.Authorization = `Basic ${token}`;
		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

/**
 * Gets Params.
 */
const getParams = function (params) {
	let pathname = window.location.pathname;
	let response = { params: {} };

	if (pathname.includes('/pt', 0))
		response.params["lang"] = 'pt'
	else if (pathname.includes('/en', 0))
		response.params["lang"] = 'en'

	if (params) {
		params.forEach(param => {
			if (param.value)
				response.params[param.key] = param.value
		});
	}

	return response;
}

/**
 * Gets a entry.
 */
export const getAction = function (cpt, value, slugOrId, recursive, author) {
	const type = slugOrId ? slugOrId : (Number(value) === NaN ? 'slug' : 'id');
	if (type == 'slug') {
		return API.get(`wp/v2/${cpt}/?${type}=${value}`, getParams([{ key: "related_recursive_calls", value: recursive }, { key: "author", value: author }])).catch((error) => {
			bus.$emit("apiError", error);
		});
	}
	else if (type == 'id') {
		return API.get(`wp/v2/${cpt}/${value}`, getParams([{ key: "related_recursive_calls", value: recursive }, { key: "author", value: author }])).catch((error) => {
			bus.$emit("apiError", error);
		});
	}
}


/**
 * Gets a list (of entries).
 */
export const listAction = function (cpt, recursive, page, author, perPage) {
	return API.get(`wp/v2/${cpt}`, getParams([{ key: "related_recursive_calls", value: recursive }, { key: "page", value: page }, { key: "author", value: author }, { key: "per_page", value: perPage }])).catch((error) => {
		bus.$emit("apiError", error);
	});
}

/**
 * Gets an entry or list.
 */
export const customAction = function (action) {
	return API.get(`wp/v2/${action}`).catch((error) => {
		bus.$emit("apiError", error);
	});
}

/**
 * Creates Entry.
 */
export const createAction = function (cpt, body, image) {
	if(image) {
		return API.post(`wp/v2/${cpt}`, body, { headers: { "Content-Disposition": "form-data; filename='image.jpg'", "Content-Type": "image/jpeg" } }).catch((error) => {
			bus.$emit("apiError", error);
		});
	} else {
		return API.post(`wp/v2/${cpt}`, body).catch((error) => {
			bus.$emit("apiError", error);
		});
	}
}

/**
 * Updates Entry.
 */
export const updateAction = function (cpt, id, body) {
	return API.put(`wp/v2/${cpt}/${id}`, body).catch((error) => {
		bus.$emit("apiError", error);
	});;;
}

/**
 * Deletes Entry.
 */
export const deleteAction = function (cpt, id, force) {
	if( force ) {
		return API.delete(`wp/v2/${cpt}/${id}?force=true`).catch((error) => {
			// bus.$emit("apiError", error);
		});
	} else {
		return API.delete(`wp/v2/${cpt}/${id}`).catch((error) => {
			// bus.$emit("apiError", error);
		});
	}
}

/**
 * Login User.
 */
// export const userLogin = function (username, password) {
// 	return API.post(`jwt-auth/v1/token`, { "username": username, "password": password }).then((response) => {
// 		VueCookies.set('user', { token: response.data.token, username: response.data.user_nicename, fullName: response.data.user_display_name })
// 		bus.$emit("loginSucess", response);
// 	}).catch((error) => {
// 		bus.$emit("loginError", error.response);
// 	})
// }






// WEBPACK FOOTER //
// ./src/data/connection.js